import { render, staticRenderFns } from "./DietaSugeridaDadosVisita.vue?vue&type=template&id=41c72b3b&"
import script from "./DietaSugeridaDadosVisita.vue?vue&type=script&lang=js&"
export * from "./DietaSugeridaDadosVisita.vue?vue&type=script&lang=js&"
import style0 from "./DietaSugeridaDadosVisita.vue?vue&type=style&index=0&id=41c72b3b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports